<template>
  <el-dialog :title=this.title :visible.sync="innerVisible" custom-class="mini-dialog" center
             :close-on-click-modal="false"
             append-to-body open>
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="16" style="text-align: center" v-if="roletype=='buy'&&status=='810'">
          <el-form-item label="供应商:" :label-width="formLabelWidth" >
            <AutoCustomer :unitgroup="3" @clear="clearPcustomer" @handleSelect="afterSelPcustomer"
                          placeholder="搜索供应商，enter键结束"></AutoCustomer>
          </el-form-item>
        </el-col>
        <el-col :span="16" style="text-align: center" v-if="roletype=='store'&&status=='500'">
          <el-form-item label="客户:" :label-width="formLabelWidth" prop="customername">
            <AutoCustomer @clear="clearCustomerName"
                          @handleSelect="afterSelExternalDept"></AutoCustomer>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10" style="text-align: center">
          <el-form-item label="发货时间:" :label-width="formLabelWidth" prop="searchdatevalue">
            <el-date-picker
              v-model="form.searchdatevalue"
              type="datetimerange"
              :value-format="'yyyy-MM-dd HH:mm:ss'"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="daochu" v-if="roletype=='buy'&&status=='810'">导 出</el-button>
      <el-button type="primary" @click="daying" v-else-if="roletype=='store'&&status=='500'">打 印</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {exportExcel, exportPdf} from '@/api/file';
  import {formatTimeToStr} from '@/plugin/Date';

  export default {
    name: "BatchBuyDaoChu",
    data() {
      return {
        title: '批量导出',
        innerVisible: false,
        formLabelWidth: '120px',
        roletype: "",//类型
        status: "",//状态
        cangkucode: '',
        form: {
          pcustomer: '',//供应商名称
          pcustomerserial: '',//供应商编码
          searchdatevalue: [],//时间段精确到时分秒
          customername: "",//客户名称
          customerserial: '',//客户编码
          address: '',//地址
          linkman: '',//联系人
          linkmanTel: '',//联系人电话
        },
        rules: {////////定义正则验证字段。
          // pcustomer: [
          //   {required: true, message: '请输入供应商', trigger: 'blur'},
          // ],
          searchdatevalue: [
            {required: true, message: '请选择时间段', trigger: 'blur'},
          ],
          customername: [
            {required: true, message: '请输入客户', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(roletype, status, cangkucode) {
        this.innerVisible = true;
        this.roletype = roletype
        this.status = status
        this.cangkucode = cangkucode
        console.log(this.roletype + " " + this.status)
      },
      //供应商清除
      clearPcustomer() {
        this.form.pcustomer = ""
        this.form.pcustomerserial = ""
      },
      //查询条件的供应商之后执行
      afterSelPcustomer(customerserial, customername, row) {
        this.form.pcustomer = customername
        this.form.pcustomerserial = customerserial

      },
      //客户清除
      clearCustomerName() {
        this.form.customername = ""
        this.form.customerserial = ""
      },
      //查询条件的门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        var addressdata = []
        if (row.deliveryaddress)
          addressdata = JSON.parse(row.deliveryaddress);
        this.form.customername = customername
        this.form.customerserial = customerserial
        //获取客户收货地址、联系人、联系电话
        for (let i in addressdata) {
          var obj = addressdata[i]
          if (obj.defalut == 1) {

            this.form.address = obj.province + obj.city + obj.county + obj.address
            this.form.linkman = obj.uname
            this.form.linkmanTel = obj.mobile
            break
          }
        }
      },
      daochu() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            exportExcel({
              pcustomer: this.form.pcustomer,//供应商名称
              pcustomerserial: this.form.pcustomerserial,//供应商编码
              startdate: formatTimeToStr(this.form.searchdatevalue[0]),//开始时间
              enddate: formatTimeToStr(this.form.searchdatevalue[1]),//结束时间
              cangkucode: "",
              businessType: 'buyerorderlist',
            })
            this.innerVisible = false
          }
        })
      },
      daying() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            var title = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate() + this.form.customername;
            exportPdf({
              customername: this.form.customername,
              customerserial: this.form.customerserial,
              startdate: formatTimeToStr(this.form.searchdatevalue[0]),//开始时间
              enddate: formatTimeToStr(this.form.searchdatevalue[1]),//结束时间
              cangkucode: "",
              address: this.form.address,
              linkman: this.form.linkman,
              linkmanTel: this.form.linkmanTel,
              datetype: '20',//按发货日期获取订单
              businessType: 'batchExport500',
            }, title);
            this.innerVisible = false
          }
        })
      },
      init() {
        this.form.searchdatevalue = []
        this.form.pcustomer = ''
        this.form.pcustomerserial = ''
        this.form.searchdatevalue[0] = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 8, 0)
        this.form.searchdatevalue[1] = new Date()
      },
    },
    mounted() {

    },
    components: {}

  }
</script>


<style scoped>
  .titlecolor {
    color: #20A0FF
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BatchBuyDaoChu.vue